"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function Toolbar(props) {
  return null;
}

exports.default = Toolbar;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-table-area@0.0.19@@alicd/crui-table-area/lib/Toolbar.js
// module id = 282
// module chunks = 0